import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { asyncRequest, requestMethod } from '../../util/apiUtil';

const ShortUrlRedirectPage = () => {
    const { shortId } = useParams();

    useEffect(() => {
        if (shortId) {
            asyncRequest({
                url: `/api/user/forms/open/form/short-url/${shortId}`,
                method: requestMethod.GET,
                success: (data) => {
                    if (data && data.url) {
                        window.location.replace(data.url);
                    } else {
                        alert("유효하지 않은 링크입니다.");
                        window.location.replace("/");
                    }
                }
            });
        }
    }, [shortId]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '1.2rem'
        }}>
            연결 중입니다...
        </div>
    );
};

export default ShortUrlRedirectPage;
